import type { ColumnDef } from '@tanstack/react-table';
import type { StreetTurnCountsRow, StreetTurnGroupBy } from '../../services/dispatcherStreetTurns.service';

const count = (row: StreetTurnCountsRow, period: string | null) => period === null ? row.total : row.periods[period] ?? 0;

export function streetTurnCountsColumns(periods: string[], groupBy: StreetTurnGroupBy): ColumnDef<StreetTurnCountsRow>[] {
  return [
    { accessorKey: 'dispatcher', header: 'Dispatcher', size: 210, footer: 'Grand Total' },
    { accessorKey: 'username', header: 'Username', size: 130 },
    ...[null, ...periods].map((period): ColumnDef<StreetTurnCountsRow> => ({
      id: period === null ? 'total' : `period_${period}`,
      header: period === null ? 'Grand Total' : `${groupBy === 'WEEK' ? 'Week of ' : ''}${period}`,
      accessorFn: row => count(row, period),
      size: groupBy === 'WEEK' ? 170 : 130,
      meta: { aggType: 'sum' },
      footer: ({ table }) => String(table.getFilteredRowModel().rows.reduce((sum, row) => sum + count(row.original, period), 0)),
    })),
  ];
}

export function streetTurnCountsExportFooter(periods: string[], rows: StreetTurnCountsRow[]): Record<string, string> {
  return {
    dispatcher: 'Grand Total',
    ...Object.fromEntries([null, ...periods].map(period => [
      period === null ? 'total' : `period_${period}`,
      String(rows.reduce((sum, row) => sum + count(row, period), 0)),
    ])),
  };
}
